import { render, staticRenderFns } from "./VerificationCancelled.vue?vue&type=template&id=1df5278a&scoped=true&"
import script from "./VerificationCancelled.vue?vue&type=script&lang=ts&"
export * from "./VerificationCancelled.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationCancelled.vue?vue&type=style&index=0&id=1df5278a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df5278a",
  null
  
)

export default component.exports